import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/seviio.webp';
import screenshot_target from '../../../images/letterfunnel/bartelverkruijssen.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Bartel Verkruijssen"
      firstname="Bartel"
      companyname="Sevi.io"
      competition="Pezesha en Two"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/bartelverkruijssen.js